import React, {useState,useEffect} from 'react'
import * as b from 'react-bootstrap'
import axios from 'axios'
import { faPaperPlane, faRedoAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import eventsdata from "./events.json";
import { faTrashAlt } from "@fortawesome/free-regular-svg-icons";

function UpdateEvent() {
    const [links,setLinks]=useState({image:"",video:""})
    const [data,setCred]=useState({eventname:"",cardImage:"",date:"",images:[],videoLinks:[],description:""})
    const [submit,setSubmit]=useState(false)
    const [resultBar,SetResultBar]=useState(false)
    const [spin, setSpin] = useState(false)
    const [select, setSelect] = useState("Select")
    const [remove, setRemove] = useState(false)
    const [reload, setReload] = useState(true)
    const [events, setEvents] = useState(eventsdata)
    const [spinDelete, setSpinDelete] = useState(false)
    
    useEffect(()=>{
        if (submit) {
            console.log(data)
            const proxyurl = "https://cors-anywhere.herokuapp.com/";
            setSpin(<b.Spinner animation="border" variant="success" />)
            console.log('posting now')
            axios.post('https://lime-rich-spider.cyclic.app/api/v1/Home/Eventgallery',data)
                    .then(response =>{
                        console.log(response.data.data.events)
                        SetResultBar(<b.Alert key={1} variant="success"><h5>Event Successfully Pushed</h5></b.Alert>)
                        setReload(true)
                    })
                    .catch(error => {
                        console.log(error)
                        SetResultBar(<b.Alert key={0} variant="danger"><h5>Error Occured in Pushing Data</h5></b.Alert>)
                        setSpin(false)
                    })  
            setSubmit(false)
            Reset()
        }
        if (reload) {
            axios.get('https://lime-rich-spider.cyclic.app/api/v1/Home/Eventgallery?sort=date')
            .then(response =>{
                console.log(response.data.data.events)
                response.data.data.events.reverse();
                setEvents(response.data.data.events)
                // this.props.update(response.data.data.projects)
            })
            .catch(error => {
                console.log(error)
            })
            setReload(false)
            setSpinDelete(false)
            setSpin(false)
        }
        if (remove) {
            setSpinDelete(<b.Spinner animation="border" variant="primary" />)
            console.log("https://lime-rich-spider.cyclic.app/api/v1/Home/Eventgallery/"+select);
            axios.delete("https://lime-rich-spider.cyclic.app/api/v1/Home/Eventgallery/"+select)
                .then(response => {
                    console.log(response);
                    SetResultBar(<b.Alert key={1} variant="success"><h5>Event Successfully Deleted</h5></b.Alert>)
                    setReload(true)

                })
                .catch(error=>{
                    console.log(error); 
                    SetResultBar(<b.Alert key={0} variant="danger"><h5>Error Occured in Deleting Data</h5></b.Alert>) 
                    setSpinDelete(false)
                })
            
            
            // Reset()
            setRemove(false)
        }
        
    },[submit,data,links,reload,remove,select])
    
    function validate(data,links){
        let dataimages=[]
        let datavideos=[]
        if (data.eventname!==""&&data.date!==""&&data.cardImage!==""&&data.description!==""&&links.image!=="") {
          // console.log("true man")
          // console.log(props)
          console.log(data)
          dataimages=links.image.split("\n")
          datavideos=links.video.split("\n")
          setCred({...data,images:dataimages,videoLinks:datavideos})
          setSubmit(true)
        //   console.log(data)
        }
        else{
            SetResultBar(<b.Alert key={2} variant="danger"><h5>Text field is Blank. Kindly fill</h5></b.Alert>)
        }
    }

    function Reset(){
        setCred({...data,eventname: "",cardImage:"",date:"",images:[],videoLinks:[],description:""})
        setLinks({...links,image:"",video:""})
        setSubmit(false)
        SetResultBar(false)
    }

    return (
        <div>
            <h1>New Event page</h1><br/>
            <h4>Add Event title</h4>
            <input type='text' value={data.eventname} style={{width:"98%", height:"35px"}} onChange={e=>setCred({...data,eventname: e.target.value})}></input><br/><br/>
            <h4>Add Event Description</h4>
            <textarea value={data.description} style={{width:"98%", height:"100px"}} onChange={e=>setCred({...data,description: e.target.value})}></textarea><br/><br/>
            <h4>Add Event Thumbnail Link</h4>
            <input type='text' value={data.cardImage} style={{width:"98%", height:"35px"}} onChange={e=>setCred({...data,cardImage: e.target.value})}></input><br/><br/>
            <h4>Add Event Date</h4>
            <input type='text' value={data.date} style={{width:"98%", height:"35px"}} onChange={e=>setCred({...data,date: e.target.value})}></input><br/><br/>
            <h4>Add Event Image Links</h4>
            <textarea value={links.image} style={{width:"98%", height:"200px"}} onChange={e=>setLinks({...links,image: e.target.value})}></textarea><br/><br/>
            <h4>Add Event Video Links</h4><h6>(Optional)</h6>
            <textarea value={links.video} style={{width:"98%", height:"200px"}} onChange={e=>setLinks({...links,video: e.target.value})}></textarea>
            <br/>
            {resultBar}
            <br/><br/>
            <b.Button variant="danger" style={{margin:"10px"}} onClick={()=>{
                Reset()
            }}>Reset  <FontAwesomeIcon icon={faRedoAlt}/></b.Button>

            <b.Button variant="success" style={{margin:"10px"}} onClick={()=>{
                validate(data,links)
            }}>Submit    <FontAwesomeIcon icon={faPaperPlane}/></b.Button> {spin}
            <br/><br/>
            <br/><br/>
            <div>
            <b.Row>
            <b.Col xs={12} md={6}>
            <b.Form>
            <b.Form.Group controlId="exampleForm.ControlSelect1" value={select} onChange={e=>{setSelect(e.target.value);console.log(e.target.value);}}>
                <b.Form.Control as="select">
                <option key={0} value={0}>------ Select Event------</option>
                {events.map((event,index)=>{
                    return(
                        <option key={index+1} value={event._id}>{index+1} ) {event.eventname}  ({event.date})</option>
                    )
                })}
                </b.Form.Control>
            </b.Form.Group>
            </b.Form>
            </b.Col>
            <b.Col xs={12} md={6}><b.Button onClick={()=>{
                setRemove(true)
                // setReload(true)
            }}>Delete Event <FontAwesomeIcon icon={faTrashAlt}/></b.Button> {spinDelete}</b.Col> 
            </b.Row>
            </div>
        </div>
    )
}

export default UpdateEvent
